// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RadarChartOutlinedSvg from "@ant-design/icons-svg/es/asn/RadarChartOutlined";
import AntdIcon from '../components/AntdIcon';

var RadarChartOutlined = function RadarChartOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RadarChartOutlinedSvg
  }));
};

RadarChartOutlined.displayName = 'RadarChartOutlined';
export default React.forwardRef(RadarChartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/RadarChartOutlined.js
// module id = 1661
// module chunks = 0